import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { wedding: String }

  connect() {
    this.key = `wm:payment-review:${this.weddingValue}:${window.location.pathname}`
    this.restore()
  }

  remember(event) {
    const row = event.target.closest("form[data-payment-review]")?.closest("tr[id]")
    if (!row) return
    try {
      sessionStorage.setItem(this.key, JSON.stringify({ row: row.id, at: Date.now() }))
    } catch (_) { /* Storage may be unavailable in a private browsing context. */ }
  }

  submitted(event) {
    if (event.detail.success === false) this.restore()
  }

  restore() {
    let saved
    try {
      saved = JSON.parse(sessionStorage.getItem(this.key))
      sessionStorage.removeItem(this.key)
    } catch (_) { return }
    if (!saved || !/^pledge-\d+$/.test(saved.row) || !Number.isFinite(saved.at) || Date.now() - saved.at > 120000 || saved.at > Date.now()) return

    const row = this.element.querySelector(`#${saved.row}`)
    const target = row || this.element.querySelector("h2")
    if (!target) return
    target.focus({ preventScroll: true })
    target.scrollIntoView({ block: "center", behavior: "auto" })
    if (row) row.classList.add("admin-reviewed-row")
  }
}
